<xemex-time-controls
  [options]="chartRangeOptions"
  [selected]="telemetryStore.deviceChartTimeOption()"
  [isTopological]="true"
  (selectedChange)="onChartRangeChanged($event)"
  (change)="onChangeEnergyTime($event)"
></xemex-time-controls>
